import administracion from "./administracion/administracion"
import usuarios from "./usuarios/usuarios"

const SICUS = {
  administracion: administracion, 
  usuarios: usuarios
}

export default SICUS


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/sistema/SICUS.js
// module id = null
// module chunks = 